import { render, staticRenderFns } from "./user.switch.lock.modal.vue?vue&type=template&id=4c92b4fb&scoped=true&"
import script from "./user.switch.lock.modal.vue?vue&type=script&lang=js&"
export * from "./user.switch.lock.modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c92b4fb",
  null
  
)

export default component.exports